import theme from "@shared/utils/themeColors";
import React from "react";

interface InputControlProps {
  id: string;
  name?: string;
  label?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  type?: string;
  disabled?: boolean;
  error?: string | null;
  required?: boolean;
  maxLength?: number;
  min?: string;
  max?: string;
  className?: string;
}

const InputControl: React.FC<InputControlProps> = ({
  id,
  name,
  label,
  value,
  onChange,
  placeholder = "",
  type = "text",
  disabled = false,
  error = null,
  required = false,
  maxLength = 255,
  min,
  max,
  className = "",
}) => {
  return (
    <div className={className}>
      {label && (
        <label
          htmlFor={id}
          className={`block text-sm font-medium ${theme.text.secondary} mb-1`}
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <input
        id={id}
        name={name || id}
        type={type}
        value={value}
        onChange={onChange}
        className={`form-input w-full ${error ? "border-red-500" : ""}`}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
        min={min}
        max={max}
      />
      {error && <div className="text-red-500 text-sm mt-1">{error}</div>}
    </div>
  );
};

export default InputControl;
